import React, { useEffect, useRef, useState } from 'react'
import { 
  Button,
  Checkbox,
  FormControlLabel,
  Grid, 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { ValidatorForm } from 'react-material-ui-form-validator';
import BuscadorPractica from '../../../coseguros/BuscadorPractica';
import { useForm } from '../../../../../hooks/useForm';
import { OBRAS_SOCIALES } from '../../../../../utils/constants';
import { addPracticaLaboratorio, addPracticaLaboratorioInSession, deletePracticaLaboratorio, getPracticasLaboratorio, resetPracticasLaboratorio, setPracticasSeleccionadasLaboratorio } from '../../../../../actions/turnos/laboratorio';
import { PracticaLabItem } from './PracticaLabItem';
import { startAlerta } from '../../../../../actions/ui/alertas';
import { TURNOS_LABORATORIO } from '../../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';

export const PracticasLaboratorioTabla = ({idObraSocial, parametros, ingresoCab = false}) => {
  const dispatch = useDispatch();
  const codigoPracticaRef = useRef(null);

  const { practicas, gruposSeleccionados } = useSelector((state) => state.laboratorio);
  const { permisos: permisosUser } =  useSelector(state => state.auth)
  const { afiliadoSeleccionado = {} } = useSelector((state) => state.autorizaciones);
  const { afiliado } = useSelector((state) => state.afiliacion);

  const [displayAddPractica, setDisplayAddPractica] = useState(false);
  const [addDefaultPr, setAddDefaultPr] = useState(false);

  const displayBotonAddPractica =  validarSoloUnPermiso(permisosUser, TURNOS_LABORATORIO.AGREGAR);

  const initialValues = {
    codigoPractica: null,
  };

  const [formValues, , , setearValor] = useForm(initialValues);

  const { codigoPractica } = formValues;

  useEffect(() => {
    if (idObraSocial === OBRAS_SOCIALES.OSPEDYC) {
      const data = {
        idEspecialidad: parametros.idEspecialidad,
        gruposSeleccionados: gruposSeleccionados.map(s => s.idGrupo).join(",")
        // idCentroMedico: parametros.idCentro,           //SE COMENTA PARA PODER REALIZAR EN CUALQUIER CENTRO 18/9
        // idEfectorFacturacion: idEfectorRed,
      };

      dispatch( getPracticasLaboratorio(data) );
    }

    return () => {
      dispatch( resetPracticasLaboratorio() );
    };
  }, [dispatch, parametros.idEspecialidad, gruposSeleccionados, idObraSocial]);

  const onClickAgregarHandler = (e) => {
    if (codigoPractica) {
      if(!Array.isArray(practicas) || practicas?.filter(s => s.idCodNom ===codigoPractica.idCodNom).length === 0){
        const practica = {
          idEfectorFacturacion: null,
          idCentroMedico: parametros.idCentro,
          idEspecialidad: parametros.idEspecialidad,
          idCodNom: codigoPractica.idCodNom,
          codNom: codigoPractica.codNom,
          desNom: codigoPractica.desNom
        };

        if(!addDefaultPr)
          dispatch(addPracticaLaboratorioInSession(practica));
        else
          dispatch(addPracticaLaboratorio(practica));
        codigoPracticaRef.current.resetValues();
        setearValor("codigoPractica", null);
        setAddDefaultPr(false);
      } else {
        dispatch(startAlerta("La practica que intenta agregar ya existe", "warning", "Atencion"));
      }
    } else {
      dispatch(startAlerta("Ingrese una practica", "warning", "Atencion"));
    }
  };

  const onClickDeleteDefaultHandler = (e) => {
    if (codigoPractica) {
      if(!Array.isArray(practicas) || practicas?.filter(s => s.idCodNom ===codigoPractica.idCodNom).length === 1){
        const practica = {
          idEfectorFacturacion: null,
          idCentroMedico: parametros.idCentro,
          idEspecialidad: parametros.idEspecialidad,
          idCodNom: codigoPractica.idCodNom,
          codNom: codigoPractica.codNom,
          desNom: codigoPractica.desNom
        };

        dispatch(deletePracticaLaboratorio(practica));
        codigoPracticaRef.current.resetValues();
        setearValor("codigoPractica", null);
        setAddDefaultPr(false);
      } else {
        dispatch(startAlerta("La practica que intenta eliminar como Default no existe en el Default", "warning", "Atencion"));
      }
    } else {
      dispatch(startAlerta("Ingrese una practica", "warning", "Atencion"));
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();    

    const practicasSeleccionados = [];

    for (const [index, practica] of practicas.entries()) {
      const checked = e.target.elements[`practica-${index}`]?.checked;
      const cantidad =
        e.target.elements[`cantidad-${index}`]?.value === ""
          ? 0
          : Number(e.target.elements[`cantidad-${index}`]?.value);
      if (!checked && cantidad > 0) {
        dispatch(
          startAlerta(
            "No se debe especificar una cantidad sin seleccionar una practica",
            "warning",
            "Atencion"
          )
        );
        return;
      } else if (checked && cantidad <= 0) {
        dispatch(
          startAlerta(
            "La cantidad de la practica seleccionada no puede ser menor o igual a 0",
            "warning",
            "Atencion"
          )
        );
        return;
      } else if (checked && cantidad > 0) {
        practicasSeleccionados.push({
          idCodNom: practica.idCodNom,
          codNom: practica.codNom,
          cantidad,
        });
      }
    }
  
    if(practicasSeleccionados.length === 0)
      return dispatch(
        startAlerta(
          "Por favor seleccione una practica",
          "warning",
          "Atencion"
        )
      );
    
    dispatch( setPracticasSeleccionadasLaboratorio(
      !ingresoCab ?afiliado.id_afiliado : afiliadoSeleccionado?.id_afiliado, 
      practicasSeleccionados, 
      parametros.idCentro, 
      null, 
      ingresoCab
    ) );             
  };

  return (
    <ValidatorForm onSubmit={submitHandler}>
      {displayAddPractica && (
        <>
          <Grid container spacing={2} style={{ width: "80%", margin: "auto" }}>
            <Grid item xs={8}>
              <BuscadorPractica
                ref={codigoPracticaRef}
                cod={codigoPractica}
                label="Código o Nombre Practica"
                fieldsDisabled={false}
                autorizacion={true}
                laboratorio={true}
                setCod={(val) => setearValor("codigoPractica", val)}
              />
            </Grid>
            <Grid item xs={2}>
              {validarSoloUnPermiso(permisosUser, TURNOS_LABORATORIO.AGREGAR_DEFAULT) &&
                <FormControlLabel
                  style={{ marginLeft: '15%', marginTop: 5 }}
                  control={
                    <Checkbox
                    name={`defaultPr`}
                    onChange={() => setAddDefaultPr(!addDefaultPr)}
                    checked={addDefaultPr}
                    />
                  }
                  label="Agregar default"
                />              
              }
            </Grid>
            <Grid item xs={2} >
              {validarSoloUnPermiso(permisosUser, TURNOS_LABORATORIO.ELIMINAR_DEFAULT) &&
                <Button
                  color="primary"
                  variant="contained"
                  style={{marginLeft: '50%'}}
                  onClick={onClickDeleteDefaultHandler}
                >
                  Eliminar Default                
                </Button> 
              }
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                margin: "1.5rem 0",
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => setDisplayAddPractica(false)}
              >
                Cancelar
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={onClickAgregarHandler}
              >
                Agregar +
              </Button>
            </Grid>
          </Grid>
        </>
      )}
      {practicas.length > 0 ? (
        <Table size={"small"}>
          <TableHead
            style={{ display: "table", width: "98.5%", tableLayout: "fixed" }}
          >
            <TableRow>
              <TableCell style={{ width: "10%" }}></TableCell>
              <TableCell style={{ width: "60%" }}>Código / Nombre Practica</TableCell>
              <TableCell style={{ width: "10%" }}>Cantidad</TableCell>
              {idObraSocial === OBRAS_SOCIALES.OSOCNA &&
                <TableCell style={{ width: "10%" }}>Autorizacion</TableCell>
              }
            </TableRow>
          </TableHead>
          <TableBody
            style={{ display: "block", maxHeight: "29rem", overflowY: "auto" }}
          >
            {practicas.map((practica, index) => {
              return (
                <PracticaLabItem
                  key={index}
                  index={index}
                  seleccion={true}
                  practica={practica}
                  cantidadDefault={practica.defaultCantidad}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <div style={{ fontStyle: "italic" }}>No hay practicas</div>
      )}
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: displayBotonAddPractica ? "space-between" : "right",
            margin: "1.5rem 0",
          }}
        >
          {displayBotonAddPractica && (
            <Button
              style={{ margin: "0 1rem" }}
              color="primary"
              variant="contained"
              onClick={() => setDisplayAddPractica(true)}
            >
              Agregar Practica +
            </Button>
          )}
        </Grid>
      </Grid>
      <Button id="btnSubmitLaboratorioStep3" style={{display: 'none'}} type="submit">
        Submit
      </Button>
    </ValidatorForm>
  )
}
